import React from 'react';

interface PlanSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectPlan: (plan: 'PRO' | 'TEAM') => void;
}

export const PlanSelectionModal: React.FC<PlanSelectionModalProps> = ({ isOpen, onClose, onSelectPlan }) => {
  if (!isOpen) return null;

  const Feature = ({ text }: { text: string }) => (
    <div className="flex items-center text-sm text-gray-600 mb-2">
      <svg className="w-4 h-4 text-green-500 mr-2 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
      </svg>
      {text}
    </div>
  );

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl overflow-hidden flex flex-col max-h-[90vh]">
        <div className="flex justify-between items-center p-6 border-b border-gray-100">
          <h2 className="text-2xl font-bold text-gray-800">Choose your plan</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl font-bold">✕</button>
        </div>

        <div className="flex-1 overflow-y-auto p-8 bg-gray-50">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            
            {/* Pro Plan Card */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 flex flex-col transition-transform hover:scale-[1.02]">
              <div className="mb-6">
                <h3 className="text-xl font-bold text-gray-900">Pro</h3>
                <p className="text-sm text-gray-500">Perfect for power users</p>
              </div>
              <div className="mb-6">
                <span className="text-4xl font-black text-gray-900">$3</span>
                <span className="text-gray-500"> / month</span>
              </div>
              <div className="flex-1 mb-8">
                <Feature text="500 MB Storage" />
                <Feature text="Email Support" />
                <Feature text="Supports Canadian Development" />
              </div>
              <button 
                onClick={() => onSelectPlan('PRO')}
                className="w-full py-3 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 transition-colors"
              >
                Get Pro
              </button>
            </div>

            {/* Team Plan Card */}
            <div className="bg-white rounded-xl border-2 border-blue-500 shadow-lg p-8 flex flex-col relative transition-transform hover:scale-[1.02]">
              <div className="absolute top-0 right-0 bg-blue-500 text-white px-3 py-1 text-xs font-bold rounded-bl-lg uppercase">
                Best for Collaboration
              </div>
              <div className="mb-6">
                <h3 className="text-xl font-bold text-gray-900">Team</h3>
                <p className="text-sm text-gray-500">For organizations and groups</p>
              </div>
              <div className="mb-6">
                <span className="text-4xl font-black text-gray-900">$5</span>
                <span className="text-gray-500"> / user / month</span>
              </div>
              <div className="flex-1 mb-8">
                <Feature text="500 MB Storage per user" />
                <Feature text="Shared Team Workspaces" />
                <Feature text="Audit/Activity Logs" />
                <Feature text="Role-Based Access Control" />
                <Feature text="Centralized Billing" />
              </div>
              <button 
                onClick={() => onSelectPlan('TEAM')}
                className="w-full py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors"
              >
                Get Team
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};